import React, { createContext, useReducer, useContext, useMemo } from 'react';
import { FONTS } from '../data/fonts';

export const DEFAULT_TEXT = 'Enter your wish here!';

const initialState = {
  textVal: DEFAULT_TEXT,
  fontFamily: FONTS[0].value,
  textScale: 1,
  textRot: 0,
  isBold: true,
  isItalic: false,
  letterSpacing: 0,
  lineSpacing: 1.1,
  fontSize: 64,
  textOffset: 0,
  textHorizontalOffset: 0,
  textHeight: 0,
  textWidth: 0,
};

function reducer(state, action) {
  switch (action.type) {
    case 'SET':
      return { ...state, [action.key]: action.value };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
}

const TextSettingsContext = createContext();

export function TextSettingsProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = useMemo(() => ({ state, dispatch }), [state]);
  return (
    <TextSettingsContext.Provider value={value}>{children}</TextSettingsContext.Provider>
  );
}

export function useTextSettings() {
  const ctx = useContext(TextSettingsContext);
  if (!ctx) throw new Error('useTextSettings must be used within TextSettingsProvider');
  return ctx;
}
